import axios from "axios";

export default (data) => {
  const uri = "/api/signup";

  return axios.post(uri, data).then((res) => res.data);
};
